class MMEDProductQuote extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.querySelector('form')?.addEventListener('submit', (event) => {
      const quoteForm = event.currentTarget;
      const artworkForm = document.getElementById(this.dataset.productForm);
      const error = this.querySelector('[data-quote-error]');
      const section = this.closest('.shopify-section');
      const pending = section?.querySelector('.filepond--item[data-filepond-item-state="processing"], .filepond--item[data-filepond-item-state="processing-queued"], .filepond--item[data-filepond-item-state="loading"], .filepond--item[data-filepond-item-state="busy"], .filepond--item[data-filepond-item-state*="error"]');
      if (pending) {
        event.preventDefault();
        error.textContent = this.dataset.uploadError;
        error.hidden = false;
        return;
      }
      error.hidden = true;
      for (const previous of quoteForm.querySelectorAll('[data-quote-property]')) previous.remove();
      for (const field of artworkForm?.elements || []) {
        if (!field.name?.startsWith('properties[') || !field.value || field.type === 'file' || field.disabled) continue;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + field.name.slice(11, -1) + ']';
        input.value = field.value;
        input.dataset.quoteProperty = '';
        quoteForm.append(input);
      }
    }, { signal: this.abortController.signal });
  }
  disconnectedCallback() { this.abortController?.abort(); }
}
if (!customElements.get('mmed-product-quote')) customElements.define('mmed-product-quote', MMEDProductQuote);
